import { LeftNavigationBarTranslation } from '@/assets/locales/menu/leftNavigationBar.translation.pl.ts';
import { RouteEnum } from '@/models/route/Route.model.ts';

export type MenuRoute = keyof LeftNavigationBarTranslation;

export const MENU_DIVIDER = 'DIVIDER';

export type MenuLayoutEntry = MenuRoute | typeof MENU_DIVIDER;

export const MENU_LAYOUT: MenuLayoutEntry[] = [
  RouteEnum.EMERGENCY_CONTACTS,
  RouteEnum.DASHBOARD,
  RouteEnum.EMAILS,
  RouteEnum.CHATS,
  RouteEnum.CALENDAR,
  RouteEnum.TASKS,
  RouteEnum.PROCESSES,
  RouteEnum.STATISTICS,
  RouteEnum.OFFERS,
  RouteEnum.CATALOG,
  RouteEnum.CONTACTS,
  RouteEnum.CUSTOMERS,
  RouteEnum.SUPPLIERS,
  RouteEnum.CARS,
  RouteEnum.HR,
  MENU_DIVIDER,
  RouteEnum.DICTIONARIES,
  RouteEnum.REPORTS,
  RouteEnum.SETTLEMENTS,
  RouteEnum.USERS,
  RouteEnum.ADMINISTRATION,
];
